import {
    useCallback,
} from 'react'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import useFilter from 'app/hooks/useFilter'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'

import requests from 'app/requests/Opportunity/Opportunity.requests'
import OpportunitiesSpreadSheet from '../OpportunitiesSpreadSheet'
import {
    OpportunityType,
} from '../opportunities.types'

const OpportunitiesBulkCreate = ({
    onClose,
}: {
    onClose: () => void
}) => {
    const filterOptions = useFilter<OpportunityType[]>()

    const {
        mutateAsync: opportunitiesCreate,
    } = useSimpleApiRequest<OpportunityType[]>({
        name: 'OpportunitiesBulkCreate',
        requestParams: requests.bulkCreate(),
        title: 'New opportunities were created',
        onSuccess: () => {
            filterOptions.setDefaultData()
        },
    })

    const onSave = useCallback(async (
        opportunities: OpportunityType[], options?: AsyncMutationOptions,
    ) => {
        await opportunitiesCreate(opportunities, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        onClose,
        opportunitiesCreate,
    ])

    return (
        <OpportunitiesSpreadSheet
            filterOptions={filterOptions}
            onSave={onSave}
            onCancel={onClose}
            enableAddNewRows
        />
    )
}

export default OpportunitiesBulkCreate
